import { useState } from 'react';

import { getNextWrappingIndex } from './getNextWrappingIndex';
import { getPreviousWrappingIndex } from './getPreviousWrappingIndex';

export const useCarousel = <T>(
  items: T[],
  startingIx = 0,
): [
  itemIx: number,
  setNextItem: () => void,
  setPreviousItem: () => void,
  jumpToItem: (ix: number) => void,
  nextDisabled: boolean,
  previousDisabled: boolean,
  reset: () => void,
  items: T[],
] => {
  const [itemIx, setItemIx] = useState(startingIx);
  const setNextItem = () => {
    setItemIx((oldItemIx) => getNextWrappingIndex(oldItemIx, items.length));
  };
  const setPreviousItem = () => {
    setItemIx((oldItemIx) => getPreviousWrappingIndex(oldItemIx, items.length));
  };
  const jumpToItem = (ix: number) => {
    setItemIx(ix);
  };

  const reset = () => {
    setItemIx(0);
  };

  const nextDisabled = itemIx === items.length - 1;

  const previousDisabled = itemIx === startingIx;

  return [
    itemIx,
    setNextItem,
    setPreviousItem,
    jumpToItem,
    nextDisabled,
    previousDisabled,
    reset,
    items,
  ];
};
